<template>
  <footer class="sf-footer">
    <div class="sf-container">
      <div class="sf-row">
        <span class="sf-paragraph">
          版权所有：&nbsp;安徽工商职业学院
          <br />
          庐阳校区地址：合肥市庐阳区北二环砀山路233号&nbsp;&nbsp;邮编：230041
          <br />
          双凤校区地址：合肥市双凤经济开发区金宁路北16号&nbsp;邮编：231131
        </span>
        <div class="sf-image-text">
          <img class="sf-image" referrerpolicy="no-referrer" :src="trafficIcon" />
          <span class="sf-text">
            网站流量：5678次
            <br />
            当前在线：5人
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  props: {
    trafficIcon: {
      type: String,
      default: () => require('../views/lanhu_shouye/assets/img/SketchPngeffa85ec7fc07e2557ace285c6e80802b9c0152dffd5b57c65ece495041d3341.png')
    }
  }
}
</script>

<style scoped>
.sf-footer { width: 100%; background-color: rgba(63, 59, 57, 1); }
.sf-container { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 16px; padding: 24px 0; max-width: 1200px; margin: 0 auto; }
.sf-row { display: flex; flex-direction: row; align-items: flex-end; justify-content: center; gap: 24px; width: 100%; }
.sf-motto { color: #e6e6e6; font-size: 14px; text-align: center; }
.sf-paragraph { color: #dddddd; font-size: 14px; line-height: 24px; margin-right: 40px; }
.sf-image-text { display: flex; flex-direction: column; align-items: center; justify-content: flex-end; }
.sf-image { width: 88px; height: 88px; }
.sf-text { color: #e6e6e6; font-size: 14px; margin-top: 6px; text-align: center; }
</style>